import axios from "../../../../../../api/axios";
import { handleApiError } from "./utils";
import { INVITATION_ENDPOINTS } from "./endpoints";

export const createInvitation = async (payload) => {
  try {
    const res = await axios.post(INVITATION_ENDPOINTS.CREATE, payload);
    return res.data.data;
  } catch (error) {
    handleApiError(error, "Failed to create invitation");
  }
};

export const getMyInvitations = async () => {
  try {
    const res = await axios.get(INVITATION_ENDPOINTS.GET_ALL);
    return res.data.data;
  } catch (error) {
    handleApiError(error, "Failed to fetch invitations");
  }
};

export const getInvitationById = async (id) => {
  try {
    const url = INVITATION_ENDPOINTS.GET_BY_ID.replace(":id", id);
    const res = await axios.get(url);
    return res.data.data;
  } catch (error) {
    handleApiError(error, "Failed to fetch invitation");
  }
};

export const resendInvitation = async (id, updates) => {
  try {
    const url = INVITATION_ENDPOINTS.RESEND.replace(":id", id);
    const res = await axios.post(url, updates || {});
    return res.data.data;
  } catch (error) {
    handleApiError(error, "Failed to resend invitation");
  }
};

export const deleteInvitation = async (id) => {
  try {
    const url = INVITATION_ENDPOINTS.DELETE.replace(":id", id);
    const res = await axios.delete(url);
    return res.data.data; 
  } catch (error) {
    handleApiError(error, "Failed to delete invitation");
  }
};